// ══════════════════════════════════════════════════════
// PeptideVault v6.5 — Master Planning Timeline (Build Note #11)
// Full-screen Gantt-style timeline with Month/Quarter/Year zoom.
// Derived visualization only — no separate data model.
// ══════════════════════════════════════════════════════

var _tlZoom = 'quarter'    // 'month' | 'quarter' | 'year'
var _tlFilter = 'current'  // 'current' | 'active' | 'upcoming' | 'completed' | 'paused' | 'all'
var _tlDetailId = null      // protocol ID for detail popover

function setTlZoom(z) { _tlZoom = z; S._tlFocusToday = true; render() }
function setTlFilter(f) { _tlFilter = f; render() }
function toggleTlDetail(pid) { _tlDetailId = _tlDetailId === pid ? null : pid; render() }
function focusTimelineToday() { S._tlFocusToday = true; render() }

function scheduleTimelineTodayFocus(rangeStart, rangeEnd, today) {
  if (!S._tlFocusToday) return
  S._tlFocusToday = false
  var startKey = fmtLD(rangeStart), endKey = fmtLD(rangeEnd)
  if (today < startKey || today > endKey) return
  var totalDays = Math.max(1, daysBetween(startKey, endKey))
  var todayOffset = Math.max(0, daysBetween(startKey, today)) / totalDays
  requestAnimationFrame(function() {
    var viewport = document.getElementById('planning-timeline-scroll')
    var canvas = document.getElementById('planning-timeline-canvas')
    if (!viewport || !canvas) return
    var labelWidth = 160
    var timelineWidth = Math.max(0, canvas.scrollWidth - labelWidth)
    var target = labelWidth + timelineWidth * todayOffset - viewport.clientWidth * .45
    viewport.scrollLeft = Math.max(0, Math.min(target, viewport.scrollWidth - viewport.clientWidth))
  })
}

function getTimelineInsights(p) {
  var overlaps = (S.protocols || []).filter(function(other){return other.id!==p.id && p.startDate && p.endDate && other.startDate && other.endDate && p.startDate<=other.endDate && p.endDate>=other.startDate})
  var dependencies = (S.protocolDependencies || []).filter(function(d){return d.protocolId===p.id || d.relatedProtocolId===p.id})
  var forecast = forecastInventory(S.protocols||[], S.peptides||[], S.inventoryReservations||[], 365).find(function(r){return r.peptideId===p.peptideId})
  return { overlaps:overlaps, dependencies:dependencies, shortfall:forecast && forecast.shortfall || 0 }
}

function renderPlanningTimelineTab() {
  var planningProtocols = (S.protocols || []).filter(function(p) { return !p.isSupplementSchedule })
  var protocols = planningProtocols.slice()
  var horizon = protocolPlanningHorizon()
  if (_tlFilter === 'current') {
    protocols = protocols.filter(function(p) { return p.status === 'active' || p.status === 'paused' || (p.status === 'upcoming' && (!p.startDate || p.startDate <= horizon.end)) })
  } else if (_tlFilter !== 'all') {
    protocols = protocols.filter(function(p) { return p.status === _tlFilter })
  }
  protocols.sort(function(a, b) { var order={active:0,upcoming:1,paused:2,completed:3};return (order[a.status]??9)-(order[b.status]??9)||(a.startDate || '').localeCompare(b.startDate || '') })

  // Determine date range
  var allDates = []
  protocols.forEach(function(p) {
    if (p.startDate) allDates.push(p.startDate)
    if (p.endDate) allDates.push(p.endDate)
  })

  var today = fmtLD(new Date())
  if (allDates.length === 0) allDates.push(today)
  var minDate = allDates.reduce(function(a, b) { return a < b ? a : b })
  var maxDate = allDates.reduce(function(a, b) { return a > b ? a : b })
  if (today < minDate) minDate = today
  if (today > maxDate) maxDate = today

  // Expand range based on zoom level
  var rangeStart = parseLD(minDate)
  var rangeEnd = parseLD(maxDate)
  // Pad to start/end of month
  rangeStart = new Date(rangeStart.getFullYear(), rangeStart.getMonth(), 1)
  rangeEnd = new Date(rangeEnd.getFullYear(), rangeEnd.getMonth() + 1, 0)

  var totalDays = Math.max(1, Math.round((rangeEnd - rangeStart) / 86400000))

  // Status counts
  var counts = { all: planningProtocols.length, current:planningProtocols.filter(function(p){return p.status==='active'||p.status==='paused'||(p.status==='upcoming'&&(!p.startDate||p.startDate<=horizon.end))}).length }
  ;['active', 'upcoming', 'completed', 'paused'].forEach(function(s) {
    counts[s] = planningProtocols.filter(function(p) { return p.status === s }).length
  })

  // Column headers based on zoom
  var columns = buildTimeColumns(rangeStart, rangeEnd, _tlZoom)
  var colW = 100 / columns.length
  scheduleTimelineTodayFocus(rangeStart, rangeEnd, today)

  var colors = ['#4F46E5', '#059669', '#D97706', '#DC2626', '#7C3AED', '#0891B2', '#CA8A04', '#BE185D']
  var statusColors = { active: 'var(--green)', upcoming: 'var(--amber)', completed: 'var(--text4)', paused: 'var(--blue)' }
  var selectedDetail = protocols.find(function(p){ return p.id === _tlDetailId })

  return '<div class="tab-content" style="animation:fadeIn .25s ease">' +
    '<div class="row" style="margin-bottom:16px;flex-wrap:wrap;gap:8px;align-items:center">' +
      '<h2 style="font-size:20px;font-weight:700">Planning Timeline</h2>' +
      '<div class="spacer"></div>' +
      '<button class="btn btn-sm btn-secondary" onclick="focusTimelineToday()">Today</button>' +
      '<div style="display:flex;gap:4px">' +
        ['month', 'quarter', 'year'].map(function(z) {
          return '<button class="btn btn-sm ' + (z === _tlZoom ? 'btn-primary' : 'btn-secondary') + '" onclick="setTlZoom(\'' + z + '\')">' +
            z.charAt(0).toUpperCase() + z.slice(1) + '</button>'
        }).join('') +
      '</div>' +
      '<select class="form-input" style="width:auto;font-size:12px" onchange="setTlFilter(this.value)">' +
        '<option value="current"' + (_tlFilter === 'current' ? ' selected' : '') + '>Current + Upcoming (' + counts.current + ')</option>' +
        '<option value="all"' + (_tlFilter === 'all' ? ' selected' : '') + '>All (' + counts.all + ')</option>' +
        '<option value="active"' + (_tlFilter === 'active' ? ' selected' : '') + '>Active (' + counts.active + ')</option>' +
        '<option value="upcoming"' + (_tlFilter === 'upcoming' ? ' selected' : '') + '>Upcoming (' + counts.upcoming + ')</option>' +
        '<option value="completed"' + (_tlFilter === 'completed' ? ' selected' : '') + '>History (' + counts.completed + ')</option>' +
        '<option value="paused"' + (_tlFilter === 'paused' ? ' selected' : '') + '>Paused (' + counts.paused + ')</option>' +
      '</select>' +
    '</div>' +

    '<div class="card planning-timeline-scroll" id="planning-timeline-scroll" style="padding:0">' +
      '<div id="planning-timeline-canvas" style="min-width:' + Math.max(600, columns.length * 80) + 'px">' +

      // Column headers
      '<div class="tl-date-header" style="display:flex;border-bottom:1px solid var(--border);background:var(--bg3)">' +
        '<div class="tl-locked-header" style="width:160px;min-width:160px;padding:8px 12px;font-size:11px;font-weight:700;color:var(--text4);text-transform:uppercase">Protocol</div>' +
        columns.map(function(col) {
          var isNow = today >= col.start && today <= col.end
          return '<div style="flex:1;padding:8px 4px;text-align:center;font-size:10px;font-weight:600;color:' + (isNow ? 'var(--accent)' : 'var(--text4)') + ';border-left:1px solid var(--border2)">' + col.label + '</div>'
        }).join('') +
      '</div>' +

      // Protocol rows
      (protocols.length === 0 ? '<div style="padding:24px;text-align:center;color:var(--text4)">No protocols match filter</div>' :
        protocols.map(function(p, i) {
          var isDetail = _tlDetailId === p.id
          var insights = getTimelineInsights(p)
          var color = colors[i % colors.length]
          var statusDot = statusColors[p.status] || 'var(--text4)'

          return '<div style="border-bottom:1px solid var(--border2)">' +
            '<div style="display:flex;min-height:44px;align-items:center">' +

              // Label column
              '<div class="tl-locked-label" style="width:160px;min-width:160px;padding:6px 12px;cursor:pointer" onclick="toggleTlDetail(\'' + p.id + '\')">' +
                '<div style="font-size:12px;font-weight:600;display:flex;align-items:center;gap:4px">' +
                  '<span style="width:6px;height:6px;border-radius:50%;background:' + statusDot + ';flex-shrink:0"></span>' +
                  esc((p.name || p.peptideName || 'Protocol').slice(0, 20)) +
                '</div>' +
                '<div style="font-size:10px;color:var(--text4)">' + (p.doseAmount || '') + ' ' + (p.doseUnit || '') + ' ' + freqLabel(p.frequency) + '</div>' +
                '<div style="display:flex;gap:3px;margin-top:2px">' + (insights.dependencies.length ? '<span class="badge" style="font-size:8px">' + insights.dependencies.length + ' link</span>' : '') + (insights.overlaps.length ? '<span class="badge badge-blue" style="font-size:8px">' + insights.overlaps.length + ' overlap</span>' : '') + (insights.shortfall ? '<span class="badge badge-red" style="font-size:8px">short ' + insights.shortfall + '</span>' : '') + '</div>' +
              '</div>' +

              // Timeline bar area
              '<div style="flex:1;display:flex;position:relative;height:44px">' +
                columns.map(function(col) {
                  var colStart = col.start
                  var colEnd = col.end
                  var barHtml = ''

                  if (p.startDate && p.endDate && p.startDate <= colEnd && p.endDate >= colStart) {
                    var clipStart = p.startDate < colStart ? colStart : p.startDate
                    var clipEnd = p.endDate > colEnd ? colEnd : p.endDate
                    var colDays = Math.max(1, daysBetween(colStart, colEnd))
                    var barStart = Math.max(0, daysBetween(colStart, clipStart)) / colDays * 100
                    var barEnd = Math.max(0, daysBetween(colStart, clipEnd)) / colDays * 100
                    var barWidth = Math.max(2, barEnd - barStart)

                    barHtml = '<div style="position:absolute;left:' + barStart + '%;width:' + barWidth + '%;top:12px;height:20px;background:' + color + ';opacity:0.8;border-radius:3px"></div>'

                    // Break markers within this column
                    ;(p.breaks || []).forEach(function(br) {
                      if (br.startDate && br.endDate && br.startDate <= colEnd && br.endDate >= colStart) {
                        var bStart = Math.max(0, daysBetween(colStart, br.startDate < colStart ? colStart : br.startDate)) / colDays * 100
                        var bEnd = Math.max(0, daysBetween(colStart, br.endDate > colEnd ? colEnd : br.endDate)) / colDays * 100
                        barHtml += '<div style="position:absolute;left:' + bStart + '%;width:' + Math.max(1, bEnd - bStart) + '%;top:12px;height:20px;background:var(--bg);opacity:0.7;border-radius:2px"></div>'
                      }
                    })
                  }

                  // Today marker
                  var todayMark = ''
                  if (today >= colStart && today <= colEnd) {
                    var colDays2 = Math.max(1, daysBetween(colStart, colEnd))
                    var todayPct = daysBetween(colStart, today) / colDays2 * 100
                    todayMark = '<div style="position:absolute;left:' + todayPct + '%;top:0;bottom:0;width:1px;background:var(--red);opacity:0.5"></div>'
                  }

                  return '<div style="flex:1;position:relative;border-left:1px solid var(--border2)">' + todayMark + barHtml + '</div>'
                }).join('') +
              '</div>' +
            '</div>' +

          '</div>'
        }).join('')
      ) +
      '</div>' +
    '</div>' +
    (selectedDetail ? renderTlDetailPanel(selectedDetail, statusColors[selectedDetail.status] || 'var(--accent)') : '') +
  '</div>'
}

function renderTlDetailPanel(p, color) {
  var events = resolveProtocolSchedule(p)
  var totalDoses = events.length
  var need = protocolPlanningNeed(p)
  var needUnit = need ? need.unit : ''
  var nextEvents = events.filter(function(e) { return e.date >= fmtLD(new Date()) }).slice(0, 5)
  var insights = getTimelineInsights(p)
  var neededMg = need ? need.amount : 0
  var peptide = (S.peptides || []).find(function(x) { return x.id === p.peptideId || x.name === p.peptideName })
  var vialPlan = (S.inventoryReservations || []).filter(function(r) { return r.protocolId === p.id }).sort(function(a,b) { return (Number(a.sequence)||9999)-(Number(b.sequence)||9999) })
  var vialPlanItems = []
  vialPlan.forEach(function(r) {
    var sku = ((peptide && peptide.skus) || []).find(function(s) { return s.id === r.skuId })
    var strength = sku ? skuStrengthForUnit(sku,needUnit) : 0
    var qty = Math.max(1, Number(r.qty != null ? r.qty : r.quantity) || 1)
    for (var q = 0; q < qty; q++) vialPlanItems.push({ strength: strength, sku: sku })
  })
  var filledMg = vialPlanItems.reduce(function(sum, item) { return sum + item.strength }, 0)
  var remainingMg = Math.max(0, neededMg - filledMg)

  return '<section class="card" style="padding:16px;margin-top:14px;max-width:920px">' +
    '<div style="display:flex;align-items:center;gap:10px;margin-bottom:12px"><div><div style="font-size:11px;font-weight:700;color:var(--text4);text-transform:uppercase">Protocol details</div><h3 style="font-size:17px;margin:2px 0 0">' + esc(p.name||p.peptideName||'Protocol') + '</h3></div><div class="spacer"></div><button class="btn btn-ghost btn-xs" onclick="toggleTlDetail(\'' + p.id + '\')">Close ✕</button></div>' +
    '<div style="display:grid;grid-template-columns:repeat(auto-fit,minmax(190px,1fr));gap:10px">' +
    '<div style="font-size:12px;line-height:1.7">' +
      '<div style="font-size:11px;font-weight:700;color:var(--text4);text-transform:uppercase;margin-bottom:4px">Schedule</div>' +
      '<div>Start: <b>' + (p.startDate || '\u2014') + '</b></div>' +
      '<div>End: <b>' + (p.endDate || '\u2014') + '</b></div>' +
      '<div>Frequency: ' + freqLabel(p.frequency) + '</div>' +
      '<div>Status: <span style="color:' + color + ';font-weight:600">' + (p.status || 'upcoming') + '</span></div>' +
      ((p.phases || []).length > 0 ? '<div>' + (p.phases || []).length + ' phase(s)</div>' : '') +
      ((p.breaks || []).length > 0 ? '<div>' + (p.breaks || []).length + ' break(s)</div>' : '') +
    '</div>' +
    '<div style="font-size:12px;line-height:1.7">' +
      '<div style="font-size:11px;font-weight:700;color:var(--text4);text-transform:uppercase;margin-bottom:4px">Dosing</div>' +
      '<div>Total doses: <b>' + totalDoses + '</b></div>' +
      (need ? '<div>Total amount: <b>' + need.amount + ' ' + need.unit + '</b></div>' : '<div style="color:var(--amber)">Unsupported or mixed units</div>') +
      '<div>Dose: ' + (p.doseAmount || '') + ' ' + (p.doseUnit || '') + '</div>' +
    '</div>' +
    '<div style="font-size:12px;line-height:1.7">' +
      '<div style="font-size:11px;font-weight:700;color:var(--text4);text-transform:uppercase;margin-bottom:4px">Upcoming</div>' +
      (nextEvents.length > 0 ? nextEvents.map(function(e) {
        return '<div>' + e.date.slice(5) + ' ' + e.doseAmount + ' ' + e.doseUnit + (e.phaseName ? ' (' + e.phaseName + ')' : '') + '</div>'
      }).join('') : '<div style="color:var(--text4)">No upcoming doses</div>') +
    '</div>' +
      '<div><div style="font-size:11px;font-weight:700;color:var(--text4);text-transform:uppercase">Dependencies</div>' + (insights.dependencies.length ? insights.dependencies.map(function(d){var target=(S.protocols||[]).find(function(x){return x.id===(d.protocolId===p.id?d.relatedProtocolId:d.protocolId)});return '<button class="btn btn-ghost btn-xs" style="display:block;margin-top:3px" onclick="toggleTlDetail(\'' + (target&&target.id||'') + '\')">' + esc(d.relationType||'related') + ' → ' + esc(target&&target.name||d.relatedCompound||'Missing protocol') + '</button>'}).join('') : '<div style="font-size:12px;color:var(--text4)">No dependencies</div>') + '</div>' +
      '<div><div style="font-size:11px;font-weight:700;color:var(--text4);text-transform:uppercase">Overlaps & Supply</div><div style="font-size:12px;color:var(--text3);margin-top:4px">' + (insights.overlaps.length ? insights.overlaps.map(function(o){return esc(o.name||o.peptideName||'Protocol')}).join(', ') : 'No overlaps') + '</div>' + (insights.shortfall ? '<div style="font-size:12px;color:var(--red);font-weight:600">Inventory shortfall: ' + insights.shortfall + ' vial(s)</div>' : '<div style="font-size:12px;color:var(--green)">Inventory covered</div>') + '</div>' +
    '</div>' +
    '<div style="grid-column:1/-1;padding:10px;border:1px solid var(--border2);border-radius:8px;background:var(--bg)">' +
      '<div style="display:flex;align-items:center;gap:8px"><div><div style="font-size:11px;font-weight:700;color:var(--text4);text-transform:uppercase">Vial Plan</div><div style="font-size:14px;font-weight:700">' + (need?neededMg+' '+needUnit+' needed':'Amount unavailable') + '</div></div><div class="spacer"></div><div style="font-size:12px;color:' + (remainingMg ? 'var(--amber)' : 'var(--green)') + '">' + filledMg + (needUnit?' '+needUnit:'') + ' assigned' + (remainingMg ? ' · ' + remainingMg + ' ' + needUnit + ' remaining' : ' · covered') + '</div><button class="btn btn-primary btn-xs" onclick="openProtocolVialPlan(\'' + p.id + '\')">Assign Vials</button></div>' +
      (vialPlanItems.length ? '<div style="display:flex;align-items:center;gap:5px;flex-wrap:wrap;margin-top:9px">' + vialPlanItems.map(function(item,index) { return '<span class="badge badge-blue" style="font-size:10px">' + (index + 1) + '. ' + (item.strength || '?') + ' ' + needUnit + '</span>' }).join('<span style="color:var(--text4)">→</span>') + '</div>' : '<div style="font-size:11px;color:var(--text4);margin-top:7px">No vials assigned yet.</div>') +
    '</div>' +
    '<div style="grid-column:1/-1;display:flex;gap:6px;margin-top:4px">' +
      '<button class="btn btn-secondary btn-xs" onclick="setTab(\'planner\')">Open Planner</button>' +
      '<button class="btn btn-secondary btn-xs" onclick="setTab(\'forecast\')">Forecast</button>' +
      '<button class="btn btn-secondary btn-xs" onclick="openModal(\'editProtocol\',{protocolId:\'' + p.id + '\'})">' + ICONS.edit + ' Edit</button>' +
    '</div>' +
  '</section>'
}

function buildTimeColumns(rangeStart, rangeEnd, zoom) {
  var columns = []
  var months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']
  var cur = new Date(rangeStart)

  if (zoom === 'month') {
    // Weekly columns
    while (cur <= rangeEnd) {
      var weekStart = new Date(cur)
      var weekEnd = new Date(cur)
      weekEnd.setDate(weekEnd.getDate() + 6)
      if (weekEnd > rangeEnd) weekEnd = new Date(rangeEnd)
      columns.push({
        label: months[weekStart.getMonth()] + ' ' + weekStart.getDate(),
        start: fmtLD(weekStart),
        end: fmtLD(weekEnd)
      })
      cur.setDate(cur.getDate() + 7)
    }
  } else if (zoom === 'quarter') {
    // Monthly columns
    while (cur <= rangeEnd) {
      var monthStart = new Date(cur.getFullYear(), cur.getMonth(), 1)
      var monthEnd = new Date(cur.getFullYear(), cur.getMonth() + 1, 0)
      columns.push({
        label: months[cur.getMonth()] + ' ' + String(cur.getFullYear()).slice(2),
        start: fmtLD(monthStart),
        end: fmtLD(monthEnd)
      })
      cur.setMonth(cur.getMonth() + 1)
    }
  } else {
    // Quarterly columns
    while (cur <= rangeEnd) {
      var q = Math.floor(cur.getMonth() / 3)
      var qStart = new Date(cur.getFullYear(), q * 3, 1)
      var qEnd = new Date(cur.getFullYear(), q * 3 + 3, 0)
      columns.push({
        label: 'Q' + (q + 1) + ' ' + cur.getFullYear(),
        start: fmtLD(qStart),
        end: fmtLD(qEnd)
      })
      cur.setMonth(q * 3 + 3)
    }
  }

  return columns
}

export {
  _tlZoom,
  _tlFilter,
  _tlDetailId,
  focusTimelineToday,
  setTlZoom,
  setTlFilter,
  toggleTlDetail,
  getTimelineInsights,
  renderPlanningTimelineTab,
  renderTlDetailPanel,
  buildTimeColumns
}
